<div class="identity-content">
  <div class="eyebrow" lang="en">DIGITAL BEHAVIORAL IDENTITY</div>
  <h2>هر خودرو، یک امضای رفتاری منحصربه‌فرد</h2>
  <p class="description">شناسه‌ای مبتنی بر الگوی حرکت، سرعت، فعالیت روزانه، ولتاژ و محدوده جغرافیایی؛ حاصل تحلیل داده‌های واقعی خودرو.</p>
  <div class="identity-fields">
    <span>شناسه دستگاه: <b dir="ltr">{{ context.summary?.strUnitID || context.unitId || '—' }}</b></span>
    <span>شناسه اثر انگشت: <b>{{ context.summary?.iVehicleFingerprint ?? '—' }}</b></span>
    <span class="status" [class.ready]="context.summary?.bFingerprintReady">
      <i class="fa" [ngClass]="context.summary?.bFingerprintReady ? 'fa-check-circle' : 'fa-clock-o'" aria-hidden="true"></i>
      {{ context.summary ? (context.summary.bFingerprintReady ? 'اثر انگشت فعال' : 'اثر انگشت آماده نیست') : 'اطلاعات اثر انگشت موجود نیست' }}
    </span>
  </div>
  <p class="period">
    بازه مرجع:
    <span dir="ltr">{{ context.summary?.dtStartDate?.slice(0, 10) || '—' }}</span>
    تا
    <span dir="ltr">{{ context.summary?.dtEndDate?.slice(0, 10) || '—' }}</span>
  </p>
  <p class="status-message" *ngIf="!context.summary?.bFingerprintReady && context.summary?.strStatusMessage">{{ context.summary?.strStatusMessage }}</p>
</div>

<div class="fingerprint-art" aria-hidden="true">
  <div class="halo"></div>
  <svg class="fingerprint-svg" viewBox="0 0 360 360" fill="none" focusable="false">
    <g stroke="#3ed7f6" stroke-linecap="round" stroke-width="2.1">
      <path *ngFor="let item of fingerprintPaths" [attr.d]="item.path" [attr.opacity]="item.opacity"></path>
      <path d="M167 165 C166 146 196 145 197 169 C199 195 189 216 180 229" stroke-width="3" opacity=".9"></path>
    </g>
    <circle cx="180" cy="180" r="144" stroke="#36c7ef" stroke-dasharray="4 9" opacity=".13"></circle>
    <circle cx="180" cy="180" r="169" stroke="#36c7ef" opacity=".13"></circle>
  </svg>
</div>
